import { ActionTypesFactory } from "../../config/helper";

export const CustomerShipmentsList = ActionTypesFactory(
  "Shipment",
  "ShipmentList"
);
export const CustomerPaymentTerms = ActionTypesFactory(
  "Payment",
  "PaymentTerms"
);
export const CustomerShipmentTerms = ActionTypesFactory(
  "Shipment",
  "ShipmentTerms"
);
export const CustomerShipmentDoc = ActionTypesFactory(
  "Shipment",
  "SingleShipment"
);
export const CustomerBillingDoc = ActionTypesFactory("Billing", "Details");
export const Claims = ActionTypesFactory("Claims", "Claims");
export const DocClaimsList = ActionTypesFactory("Claims", "DocClaimsList");
export const DownloadDocClaimList = ActionTypesFactory(
  "Claims",
  "DownloadDocClaimList"
);
export const ClaimDetails = ActionTypesFactory("Claims", "Details");
export const SubmitClaims = ActionTypesFactory("SubmitClaims", "Claims");
export const CreditNotes = ActionTypesFactory("CreditNotes", "Claims");
export const CustomerBillingList = ActionTypesFactory(
  "Billing",
  "PaymentsList"
);
export const CustomerShipmentTrack = ActionTypesFactory(
  "Shipment",
  "TrackShipment"
);
export const CustomerOnWaterReport = ActionTypesFactory(
  "Shipment",
  "OnWaterReport"
);
export const CustomerInvReport = ActionTypesFactory(
  "Products",
  "InventoryReport"
);
export const CustomerShipmentDetails = ActionTypesFactory(
  "Shipment",
  "Details"
);
export const ShipmentHistory = ActionTypesFactory("Shipment", "History");
export const SyncCustomerOrders = ActionTypesFactory("Sync", "Orders");
export const SyncCustomerDetails = ActionTypesFactory(
  "Sync",
  "CustomerDetails"
);

export const get_claims = (payload) => {
  return { type: Claims.REQUEST, payload };
};
export const shipment_history = (payload) => {
  return { type: ShipmentHistory.REQUEST, payload };
};

export const cust_inv_rep = (payload) => {
  return { type: CustomerInvReport.REQUEST, payload };
};

export const doc_claims_list = (payload) => {
  return { type: DocClaimsList.REQUEST, payload };
};

export const download_doc_claim_list = (payload) => {
  return { type: DownloadDocClaimList.REQUEST, payload };
};

export const get_claim = (payload) => {
  return { type: ClaimDetails.REQUEST, payload };
};

export const credit_notes = (payload) => {
  return { type: CreditNotes.REQUEST, payload };
};

export const submit_claims = (payload) => {
  return { type: SubmitClaims.REQUEST, payload };
};

export const customerShipmentsList = (payload) => {
  return { type: CustomerShipmentsList.REQUEST, payload };
};

export const customerShipmentDetails = (payload) => {
  return { type: CustomerShipmentDetails.REQUEST, payload };
};
export const customerPaymentTerms = (payload) => {
  return { type: CustomerPaymentTerms.REQUEST, payload };
};
export const customerShipmentTerms = (payload) => {
  return { type: CustomerShipmentTerms.REQUEST, payload };
};
export const customerShipmentDoc = (payload) => {
  return { type: CustomerShipmentDoc.REQUEST, payload };
};
export const customerBillingDoc = (payload) => {
  return { type: CustomerBillingDoc.REQUEST, payload };
};
export const customerBillingList = (payload) => {
  return { type: CustomerBillingList.REQUEST, payload };
};
export const customerShipmentTrack = (payload) => {
  return { type: CustomerShipmentTrack.REQUEST, payload };
};
export const syncCustomerOrders = (payload) => {
  return { type: SyncCustomerOrders.REQUEST, payload };
};
export const syncCustomerDetails = (payload) => {
  return { type: SyncCustomerDetails.REQUEST, payload };
};
export const customerOnWaterReport = (payload) => {
  return { type: CustomerOnWaterReport.REQUEST, payload };
};
